import { render, staticRenderFns } from "./platStatistics.vue?vue&type=template&id=0a1869a4&scoped=true&"
import script from "./platStatistics.vue?vue&type=script&lang=js&"
export * from "./platStatistics.vue?vue&type=script&lang=js&"
import style0 from "./platStatistics.vue?vue&type=style&index=0&id=0a1869a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1869a4",
  null
  
)

export default component.exports